import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María González', 'Juan Pérez', 'Carolina Rodríguez', 'Martín López', 'Lucía Fernández', 'Facundo Herrera', 'Camila Silva', 'Diego Martínez', 'Sofía Castro'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    // Interval for subsequent popups (every 12-20 seconds)
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.floor(Math.random() * 8000) + 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-259">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-4 max-w-sm" data-id="element-260">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-261">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-262" />
        </div>
        <div data-id="element-263">
          <p className="text-sm text-gray-800 font-medium" data-id="element-264">
            <span className="font-bold" data-id="element-265">{currentName}</span> de {currentCity}{' '}
            acaba de comprar
          </p>
          <p className="text-xs text-blue-600 font-bold mt-1" data-id="element-266">
            Marketing Jurídico 360 con IA
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-267">Hace unos minutos</p>
        </div>
      </div>
    </div>;
}